export function omitNull(obj: Record<any, any>): any {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== null));
}

export function omitUndefined(obj: Record<any, any>): any {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
}

export function camelCase(str: string): string {
  return str
    .replace(/_/g, ' ')
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '');
}
